import { Tour } from "../TourProvider.types";

export const TourProjectSharingPS: Tour = {
  name: "Project Sharing",
  pages: ["projectHome"],
  conditions: { isProjectAdmin: true, isPersonalSpace: true },
  description: "Learn how to invite others to view this project.",
  steps: [
    {
      anchorId: "projectAccess",
      title: "Project Access Settings",
      content:
        "Use this tab to share view-only access to this project with others via email.",
    },
    {
      anchorId: "external-access-settings",
      title: "Invite viewers by email",
      content:
        "If you would like to invite people to view this project, you can add them by email here. If they do not have an account, they will be sent a link to create one.",
    },
  ],
};
